import { Box, Grid, Tooltip, Typography } from '@mui/material'
import React, { useLayoutEffect, useRef, useState } from 'react'
import Calendar from '../components/Calendar/Calendar'
import '../css/index.css'
import { FaRegCalendarAlt } from "react-icons/fa";
import { LuClipboardList } from "react-icons/lu";

import { useCalendarEvent } from '../hooks/useFundActionPlan';

import moment from 'moment';

const FundPlanCalendar = () => {

    const { arrEvent, arrActivity, onCalenderChange } = useCalendarEvent();

    return (
        <Grid container spacing={2}>
            <Grid item xs={8}>
                <Calendar
                    Event={[...arrEvent]}
                    // Event={[
                    //     { title: 'Meeting', start: new Date(), end: new Date("2024-03-25"), allDay: true }
                    //     // Add more calendar events as needed
                    // ]}
                    // OnDateClick={OnDateClick}
                    initialView={true}
                    onCalenderChange={(e) => {
                        onCalenderChange(e);
                    }}
                    height={320}
                    maxWidth={'100%'}
                    small={true}
                />
            </Grid>
            <Grid item xs={4}>
                <Grid container spacing={2} padding={"1rem"} paddingLeft={0}>
                    <Grid item xs={12}>
                        <Box sx={{ display: "flex", padding: "0.75rem 0", alignItems: "center" }}>
                            <FaRegCalendarAlt style={{ color: "rgb(52, 71, 103)", fontSize: "1.25rem", marginRight: "0.5rem" }} /> <Typography sx={{ fontWeight: 700, color: "rgb(52, 71, 103)", fontSize: "1rem" }}>การประชุมคณะกรรมการ/คณะอนุกรรมการที่เกี่ยวข้อง</Typography>
                        </Box>
                    </Grid>
                    {arrEvent.length === 0 &&
                        <Grid item xs={12} sx={{ height: 200 }}>
                            <Box sx={{ width: "100%", borderRadius: "0.5rem", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px", display: "flex", padding: "0.75rem", alignItems: "center", justifyContent: "center" }}>
                                ไม่พบข้อมูล
                            </Box>
                        </Grid>
                    }
                    <Grid item xs={12} sx={{ maxHeight: 350, overflow: "scroll" }}>
                        {arrEvent.map((m, i) => {
                            let dStart = moment(m.start).add(543, "year").startOf("month").locale('th-TH');
                            let dEnd = moment(m.end).add(543, "year").add(-1, "day").startOf("month").locale('th-TH');
                            let isSameDate = dStart.isSame(dEnd);
                            let isSameYear = dStart.isSame(dEnd, "year");
                            return (
                                <Grid item xs={12} key={m.sID} sx={{ margin: "8px 0" }}>
                                    <Grid item xs={12} sx={{ width: "100%", borderRadius: "0.5rem", padding: "10px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px", borderLeft: "5px solid", borderColor: m.backgroundColor }}>
                                        {!isSameDate ?

                                            isSameYear ?
                                                <>
                                                    <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, color: "#750102", lineHeight: 1 }}>{dStart.format("MMM")} - {dEnd.format("MMM")} {dEnd.format("YYYY")}</Typography>
                                                </>
                                                :
                                                <>
                                                    <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, color: "#750102", lineHeight: 1 }}>{dStart.format("MMM")} {dStart.format("YYYY")} - {dEnd.format("MMM")} {dEnd.format("YYYY")}</Typography>

                                                </>
                                            :
                                            <>
                                                <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, color: "#750102", lineHeight: 1 }}>{dStart.format("MMM")} {dStart.format("YYYY")}</Typography>
                                            </>
                                        }
                                        <div style={{ paddingTop: "8px" }}>
                                            <Typography sx={{ fontWeight: 500, color: "rgb(52, 71, 103)", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} ><Tooltip title={m.sTopic} style={{ cursor: "pointer" }} arrow disableHoverListener={m.sTopic.length < 35}><b><i>{m.sTopic}</i></b></Tooltip></Typography>
                                            <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} ><Tooltip title={m.sEvent} style={{ cursor: "pointer" }} arrow disableHoverListener={m.sEvent.length < 35}>{m.sEvent}</Tooltip></Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Grid>
                <Grid container spacing={2} padding={"1rem"} paddingLeft={0}>
                    <Grid item xs={12}>
                        <Box sx={{ display: "flex", padding: "0.75rem 0", alignItems: "center" }}>
                            <LuClipboardList style={{ color: "rgb(52, 71, 103)", fontSize: "1.25rem", marginRight: "0.5rem" }} /> <Typography sx={{ fontWeight: 700, color: "rgb(52, 71, 103)", fontSize: "1rem" }}>กิจกรรม</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} paddingTop={0}>
                        <Box sx={{ height: 250, padding: "16px", border: "1px dashed #1580c6", borderRadius: "20px", overflow: "scroll" }}>
                            {arrActivity.length === 0 ?
                                <div className="flex-center">
                                    ไม่พบข้อมูล
                                </div>
                                :
                                <ul className="Fund-Bullet">
                                    {arrActivity.map((m, i) => (
                                        <li key={m.sID}>{m.sActivity}</li>
                                    ))}
                                </ul>
                            }
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    )
}

export default FundPlanCalendar